/**
 * The in-hand trident (vanilla TridentModel on entity/trident/trident.png, 32x32), shared by the
 * first-person hand and the third-person body. Block units, model-up (+y) = the prongs, origin at
 * the grip (14 px below the base), so it can be parented to a hand frame and pointed with plain
 * rotations. The thrown-trident renderer builds the same parts in its own flight frame.
 */

import * as THREE from 'three';
import { mergeGeometries } from 'three/examples/jsm/utils/BufferGeometryUtils.js';
import { boxGeometry } from './firstPerson';

export const TRIDENT_TEX = 'mc/entity/trident/trident.png';

let geo: THREE.BufferGeometry | null = null;
/** pole 1x25x1, base 3x2x1, three 1x4x1 spikes (vanilla y-down px, flipped here so the prongs point +y). */
export function tridentGeometry(): THREE.BufferGeometry {
  if (geo) return geo;
  const parts = [
    boxGeometry(0, 6, -0.5, 2, -0.5, 1, 25, 1, 0, 32, 32),
    boxGeometry(4, 0, -1.5, 0, -0.5, 3, 2, 1, 0, 32, 32),
    boxGeometry(4, 3, -2.5, -3, -0.5, 1, 4, 1, 0, 32, 32),
    boxGeometry(0, 0, -0.5, -4, -0.5, 1, 4, 1, 0, 32, 32),
    boxGeometry(4, 3, 1.5, -3, -0.5, 1, 4, 1, 0, 32, 32),
  ];
  const g = mergeGeometries(parts.map((p) => (p.index ? p.toNonIndexed() : p)))!;
  g.translate(0, -14 / 16, 0);
  g.scale(1, -1, -1); // y down -> up; keeps the winding right by also flipping z
  return (geo = g);
}
